import * as React from "react"
import * as styles from '../styles/press_kit_section.module.css'
import { Header1 } from "./heading_elements";

export function PressKitSection() {
    const driveLink = "https://drive.google.com/uc?export=download&id=1SY9GCP40B6IIFg99qQgfkIG_Y81Xab_Z" 
    return (
        <section className={styles.section_press_kit}>
          <Header1 headerTitle={"プレスキット"} />
          <a className={styles.press_kit_button} href={driveLink}>
              <p className={styles.press_kit_button_text}>資料ダウンロード</p>
              <img className={styles.download_icon} src="icon/download.png" alt="press_kit"/>
          </a>
        </section>
    )
  }
  